module.exports = __webpack_public_path__ + "static/media/CC-COL2_1PLZwHKjMfezer6ngabdM9MUWG2Bvcej8.d2faca00.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-COL2_1PLZwHKjMfezer6ngabdM9MUWG2Bvcej8
// module id = 776
// module chunks = 0